import { render, staticRenderFns } from "./MitraView.vue?vue&type=template&id=048eb447&"
import script from "./MitraView.vue?vue&type=script&lang=js&"
export * from "./MitraView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports